module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "photo-galleries"
    }
  }, [_c('list', {
    ref: "list",
    attrs: {
      "scroll": true,
      "items": _vm.galleries,
      "link": "photoGallery",
      "fields": ['title', 'date', 'author'],
      "type": "img"
    },
    on: {
      "update": _vm.load
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dfbc60e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/webzine/PhotoGalleries.vue
// module id = 253
// module chunks = 0